import { Component, inject } from '@angular/core';
import { ThemeService } from '../../../theme.service';
import { LanguageModalComponent } from '../language-modal/language-modal.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [LanguageModalComponent, TranslateModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css',
})
export class HeaderComponent {
  isMenuDisabled = false;

  private readonly themeService = inject(ThemeService);

  public toggle(): void {
    this.isMenuDisabled = !this.isMenuDisabled;
  }

  public switchTheme(): void {
    this.themeService.switchTheme();
  }
}
